import { render, staticRenderFns } from "./HelperTagCategoryList.vue?vue&type=template&id=067124a1&scoped=true"
import script from "./HelperTagCategoryList.vue?vue&type=script&lang=js"
export * from "./HelperTagCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067124a1",
  null
  
)

export default component.exports